import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default function ModalErreurCompte(props) {
  const { t } = useTranslation();
  const [styleFadeIn, setFadeIn] = useState(true);
  const CloseModalErreurCompte = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.closeModaErreurCompte();
    }, 400);
  }, []);

  return (
    <StyleRoot>
      <div
        className="modal show modal-skin"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        id="modalConfirm"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                CloseModalErreurCompte();
              }}
            >
              <button
                onClick={CloseModalErreurCompte}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close src="img/close.svg" className="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <section>
                  <h5 className="modal-title">{t('creche.disable_account_title')}</h5>
                </section>
                <section>
                  <h5>
                    {t('creche.error_only_admin')}
                  </h5>
                </section>
                <p className="bottom-space"></p>
                <section>
                  <div className="d-flex justify-content-center">
                    <button type="submit" className="btn-gradient btn-confirm">
                      <img
                        src="img/icon-check-white.svg"
                        className="img-fluid"
                        alt=""
                      />{" "}
                      Ok
                    </button>
                  </div>
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
